import React from 'react'
import View from './view'
import useGetBalance from '../../../hooks/useGetBalance'

const AvailableBalance = () => {
    let balance= useGetBalance()
    return <View balance = {balance}/>
}

export default AvailableBalance